function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var BasicBundle = Oskari.clazz.get('Oskari.BasicBundle');
/**
 * @class Oskari.sample.info.SampleInfoBundleInstance
 */
Oskari.clazz.defineES('Oskari.sample.info.SampleInfoBundleInstance', /*#__PURE__*/function (_BasicBundle) {
  function SampleInfoBundleInstance() {
    var _this;
    _classCallCheck(this, SampleInfoBundleInstance);
    _this = _callSuper(this, SampleInfoBundleInstance);
    _this.__name = 'SampleInfoBundleInstance';
    _this.loc = Oskari.getMsg.bind(null, 'sample-info');
    return _this;
  }
  _inherits(SampleInfoBundleInstance, _BasicBundle);
  return _createClass(SampleInfoBundleInstance, [{
    key: "_startImpl",
    value: function _startImpl(sandbox) {
      this._registerForGuidedTour();
    }

    /**
     * @method _registerForGuidedTour
     * Registers bundle for guided tour help functionality. Waits for guided tour load if not found
     */
  }, {
    key: "_registerForGuidedTour",
    value: function _registerForGuidedTour() {
      var _this2 = this;
      var sendRegister = function sendRegister() {
        var requestBuilder = Oskari.requestBuilder('Guidedtour.AddToGuidedTourRequest');
        if (requestBuilder && _this2.sandbox.hasHandler('Guidedtour.AddToGuidedTourRequest')) {
          var delegate = {
            bundleName: _this2.getName(),
            priority: 5,
            getTitle: function getTitle() {
              return _this2.loc('guidedTour.title');
            },
            getContent: function getContent() {
              return _this2.loc('guidedTour.message');
            },
            getPositionRef: function getPositionRef() {
              return jQuery('#login');
            },
            positionAlign: 'right'
          };
          _this2.sandbox.request(_this2, requestBuilder(delegate));
        }
      };
      var tourInstance = this.sandbox.findRegisteredModuleInstance('GuidedTour');
      if (tourInstance) {
        sendRegister();
      } else {
        Oskari.on('bundle.start', function (msg) {
          if (msg.id === 'guidedtour') {
            sendRegister();
          }
        });
      }
    }
  }]);
}(BasicBundle), {
  protocol: ['Oskari.bundle.BundleInstance', 'Oskari.mapframework.module.Module']
});